import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import i18n from '@/plugins/lang/i18n';
Vue.config.productionTip = false
//============in-built plugins===============
import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize);

import Notifications from 'vue-notification'
Vue.use(Notifications);

import VueFeather from 'vue-feather';
Vue.use(VueFeather);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll);

Vue.use(require('vue-moment'));


// import VueSimpleScrollbar from 'vue-simple-scrollbar'
// import { OverlayScrollbarsPlugin , OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
// Vue.use(OverlayScrollbarsPlugin);
// Vue.component('vue-scrollbar', OverlayScrollbarsComponent );
//Vue.use(VueSimpleScrollbar);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('30d')
Vue.$cookies.config('7d', '', '', true)
//===================import components ===========================
import AppLoading from './components/website//copy-trade/dashboard-loader.vue'
Vue.component('AppLoading', AppLoading)
import loader from './components/website/shared/loader'
Vue.component('app-loader', loader)
import header from './components/website/shared/header'
Vue.component('app-header', header)
//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
//===================== vue pagination ============================
import pagination from './components/website/shared/pagination'
Vue.component('pagination', pagination)
// ========chart loader===============
import chart_loader from './components/website/shared/chart-loader'
Vue.component('chart-loader', chart_loader)
// ========chart loader===============
import no_data from './components/website/shared/no-data'
Vue.component('no-data', no_data)

import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)

Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
// ChartIQ
// window._ 	= require('../static/website/js/chartiq.js');
// // window._     = require('../static/website/js/chartIQ/stxAdvanced.js');
// window.__ 	= require('../static/website/js/quoteFeedSimulator.js');
Vue.prototype.$env_var = process.env

new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js